import * as React from 'react';
import {defineMessage} from 'react-intl';
import {BuildInstructions} from '../../components/left-col';

export const buildInstructions = [
  {
    label: 'pip',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.python.pip.body',
        defaultMessage: 'Install the package via pip:',
      }),
    },
    command: 'pip3 install stripe',
  },
  {
    label: 'GitHub',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.python.github.body',
        defaultMessage:
          'Download the stripe-python library source code directly ',
        description:
          'First part of a sentence that ends in docsApp.ib.aap.snippets.python.github.link . Please translate them with this in mind.',
      }),
    },
    link: {
      href: 'https://github.com/stripe/stripe-python/releases',
      label: {
        message: defineMessage({
          id: 'docsApp.ib.aap.snippets.python.github.link',
          defaultMessage: 'from GitHub.',
          description:
            'Second part of a sentence that begins in with docsApp.ib.aap.snippets.python.github.body . Please translate them with this in mind.',
        }),
      },
    },
  },
];

export const setup = {
  heading: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.python.setup.heading',
      defaultMessage: 'Install the Stripe Python package',
    }),
  },
  body: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.python.setup.body',
      defaultMessage:
        'Install the Stripe package and import it in your code. Alternatively, if you’re starting from scratch and need a requirements.txt file, download the project files using the link in the code editor.',
    }),
  },
  Component() {
    return <BuildInstructions instructions={buildInstructions} />;
  },
};

export const run = 'python3 -m flask run --port=4242';
